<template>
	<UIColorIndicator
		:iconClassName="iconClass"
		:dataBg="dataBg"
		:dataColor="dataColor"
		:indicatorValue="indicatorValue"
		:width="width"
		:height="height"
		:fontSize="fontSize"
	/>
</template>

<script>
import UIColorIndicator from '@/components/visual/ui-color-indicator/ui-color-indicator.vue';
export default {
	name: 'TabIconBadge',
	components: {
		UIColorIndicator
	},
	data() {
		return {
			indicatorConfig: {
				data: {
					iconClassName: 'icon-info',
					dataBg: '',
					dataColor: 'neutral'
				},
				pending: {
					iconClassName: 'icon-warning-01',
					dataBg: '',
					dataColor: 'warning'
				},
				warning: {
					iconClassName: 'icon-warning-01',
					dataBg: '',
					dataColor: 'warning'
				},
				error: {
					iconClassName: 'icon-warning',
					dataBg: '',
					dataColor: 'negative'
				}
			}
		};
	},
	props: {
		// possible options: 'data', 'pending','warning', 'error'
		indicator: {
			type: String,
			default: null
		},
		tabIcon: {
			type: Object,
			default: null
		},
		isActive: {
			type: Boolean,
			default: false
		},
		indicatorValue: {
			type: [String, Number],
			default: null
		},
		width: {
			type: [String, Number],
			default: null
		},
		height: {
			type: [String, Number],
			default: null
		},
		fontSize: {
			type: [String, Number],
			default: null
		},
	},
	computed: {
		currentConfig() {
			if (this.tabIcon) {
				return {
					iconClassName: this.tabIcon.iconClassName,
					dataBg: this.tabIcon.dataBg,
					dataColor: this.tabIcon.dataColor
				};
			}
			return this.indicatorConfig[this.indicator];
		},
		iconClass() {
			return this.currentConfig ? this.currentConfig.iconClassName : null;
		},
		dataBg() {
			if (this.isActive) {
				return 'accessible-need';
			}
			return this.currentConfig ? this.currentConfig.dataBg : null;
		},
		dataColor() {
			return this.currentConfig ? this.currentConfig.dataColor : null;
		}
	}
};
</script>

<style lang="scss" scoped>
</style>
